interface Props {
  className?: string;
}
export const DepositIcon = ({ className }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ?? ""}
    >
      <mask
        id="mask0_1084_3405"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="var(--swapper-text-color)" />
      </mask>
      <g mask="url(#mask0_1084_3405)">
        <path
          d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V6C2 5.63333 2.13056 5.31944 2.39167 5.05833C2.65278 4.79722 2.96667 4.66667 3.33333 4.66667H6V6H3.33333V12.6667H12.6667V6H10V4.66667H12.6667C13.0333 4.66667 13.3472 4.79722 13.6083 5.05833C13.8694 5.31944 14 5.63333 14 6V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM8 10.6667L5.33333 8L6.26667 7.06667L7.33333 8.11667V0H8.66667V8.11667L9.73333 7.06667L10.6667 8L8 10.6667Z"
          fill="var(--swapper-text-color)"
          className={className ?? ""}
        />
      </g>
    </svg>
  );
};
